<template lang="pug">
  div(class="documents-signed-success")
    div(class="documents-signed-success__image")
      v-img(
        :src="require('~/assets/images/check-green.png')"
        max-width="80"
      )
    div(class="documents-signed-success__content")
      h3(
        class="mb-2"
        :class="[xsDevice ? 'title-20px' : 'title-32px bold']"
      ) {{ title }}
      p(class="text-14px light mb-8") {{ text }}
    div(
      class="documents-signed-success__actions"
      :class="{ solo: isInformationDialog }"
    )
      template(v-if="isInformationDialog")
        v-btn(
          class="main-button w-100"
          @click="closeModal(true)"
        ) {{ $t('Ok') }}
      template(v-else)
        v-btn(
          @click="closeModal(false)"
          height="48"
        ) {{ $t('Skip') }}
        v-btn(
          class="main-button"
          @click="submit"
        ) {{ buttonText }}
</template>

<script>
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'BlockDocumentsSuccess',
  mixins: [responsive],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: null
    },
    onSubmit: {
      type: Function,
      default: null
    },
    isInformationDialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submit() {
      if (typeof this.onSubmit === 'function') {
        this.onSubmit()
      }
      this.closeModal()
    }
  }
}
</script>

<style scoped lang="scss">
.documents-signed-success {
  &__image {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }

  &__content {
    text-align: left;
  }

  &__actions {
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 16px;

    @media (min-width: map-get($breakpoints, 'md')) {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: none;
    }

    &.solo {
      grid-template-rows: 1fr;
      gap: 0;

      @media (min-width: map-get($breakpoints, 'md')) {
        grid-template-columns: 1fr;
        gap: 0;
        grid-template-rows: none;
      }
    }
  }
}
</style>
